import { render } from "./PmLocalList.vue?vue&type=template&id=10d783f2"
import script from "./PmLocalList.vue?vue&type=script&lang=js"
export * from "./PmLocalList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__